export const BrandBackdrop = () => (
  <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true" data-testid="brand-backdrop">
    <div className="absolute inset-0 bg-white" />
    <div className="absolute inset-0 grid grid-cols-2 lg:grid-cols-3">
      <img src="/images/bg-truck-side.jpg" alt="" className="h-full w-full object-cover" />
      <img src="/images/bg-movers-loading.jpg" alt="" className="h-full w-full object-cover" />
      <img src="/images/bg-movers-boxes.jpg" alt="" className="hidden h-full w-full object-cover lg:block" />
    </div>
    <div className="absolute inset-0 bg-white/[0.52]" />
  </div>
);
